import { IContainer } from '../../interface/container';
import {
    bindAuthAPI,
    bindMediaAPI,
    bindMediaDiffAPI,
    bindSiteDataAPI,
    unbindAuthAPI,
    unbindMediaAPI,
    unbindMediaDiffAPI,
    unbindSiteDataAPI,
} from '../interface/bind';
import mediaApiInst from '../impl/media.bind';
import authApiInst from '../impl/auth.bind';
import mediaDiffApiInst from '../impl/mediaDiff.bind';
import siteDataApiInst from '../impl/siteData.bind';

function bind(container: IContainer) {
    bindMediaAPI(mediaApiInst(container), container);
    bindAuthAPI(authApiInst(container), container);
    bindMediaDiffAPI(mediaDiffApiInst(container), container);
    bindSiteDataAPI(siteDataApiInst(container), container);
}

function unbind(container: IContainer) {
    unbindMediaAPI(container);
    unbindAuthAPI(container);
    unbindMediaDiffAPI(container);
    unbindSiteDataAPI(container);
}

const module = {
    bind,
    unbind,
};

export default module;
